'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

exports.switchLanguage = switchLanguage;
exports.t = t;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//中转作用
var __Locale__ = void 0;
//切换后的语言列表
var changedLanguageList = void 0;
//后面会赋值
var getLanguageSpecificListTemp = void 0;
function switchLanguage(language) {
  if (!getLanguageSpecificListTemp) {
    console.error('switchLanguage 先执行getLanguageSpecificListTemp为undefined.');
    return;
  }
  var languageListPromise = getLanguageSpecificListTemp && getLanguageSpecificListTemp(language);
  if (!languageListPromise.then && !languageListPromise.catch) {
    console.error('"getLanguageSpecificList" should return promise!');
    return;
  }
  return languageListPromise.then(function (languageList) {
    if (!languageList) {
      return false;
    }
    //兼容es6语法
    languageList = languageList.default || languageList;
    //记录当前的language
    localStorage.currentLanguage = language;
    changedLanguageList = languageList;
    return languageList;
  });
}

function t(str) {
  if (changedLanguageList) {
    var o = changedLanguageList[__Locale__[str]];
    if (o) {
      return o;
    }
  }
  return str;
}

/**
 * @prop { function } getLanguageSpecificList 获取指定的语言列表，返回promise对象
 * 参数为各种语言的标识字符串，返回指定语言的数组列表（promise对象）
 */
var I18nProvider = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(I18nProvider, _React$Component);

  function I18nProvider() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, I18nProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = I18nProvider.__proto__ || (0, _getPrototypeOf2.default)(I18nProvider)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'I18nProvider', _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(I18nProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          getLanguageSpecificList = _props.getLanguageSpecificList,
          _props$defaultLanguag = _props.defaultLanguageList,
          defaultLanguageList = _props$defaultLanguag === undefined ? [] : _props$defaultLanguag;

      getLanguageSpecificListTemp = getLanguageSpecificList;
      if (!__Locale__) {
        __Locale__ = {};
        defaultLanguageList.forEach(function (v, k) {
          __Locale__[v] = k;
        });
      }
      if (localStorage.currentLanguage) {
        var switchLanguagePromise = switchLanguage(localStorage.currentLanguage);
        if (switchLanguagePromise && switchLanguagePromise.then) {
          switchLanguagePromise.then(function (languageList) {
            _this2.setState({
              canRender: true
            });
          });
        }
      } else {
        this.setState({
          canRender: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          I18nLoading = _props2.I18nLoading;
      var canRender = this.state.canRender;

      if (!canRender && localStorage.currentLanguage) {
        if (I18nLoading) {
          return _react2.default.createElement(I18nLoading, null);
        }
        return false;
      } else {
        return _react2.default.createElement(
          'span',
          null,
          children
        );
      }
    }
  }]);
  return I18nProvider;
}(_react2.default.Component), _class.propTypes = {
  getLanguageSpecificList: _propTypes2.default.func.isRequired,
  defaultLanguageList: _propTypes2.default.array.isRequired,
  I18nLoading: _propTypes2.default.element
}, _temp2);
exports.default = I18nProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mvc-react/libs/i18n-provider.js
// module id = 550
// module chunks = 0